/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseImageSeriesField
 */
export interface DatabaseImageSeriesField extends DatabaseField {
}

/**
 * Check if a given object implements the DatabaseImageSeriesField interface.
 */
export function instanceOfDatabaseImageSeriesField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseImageSeriesFieldFromJSON(json: any): DatabaseImageSeriesField {
    return DatabaseImageSeriesFieldFromJSONTyped(json, false);
}

export function DatabaseImageSeriesFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageSeriesField {
    return json;
}

export function DatabaseImageSeriesFieldToJSON(value?: DatabaseImageSeriesField | null): any {
    return value;
}

